angular.module("avant.interceptors")
.config(['$httpProvider', ($httpProvider) ->
  try $httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content') catch
])
.run(['$rootScope', '$http', ($rootScope, $http) ->
  try $rootScope.csrf_token = $http.defaults.headers.common['X-CSRF-TOKEN'] catch
])
.factory('tokenAuthInterceptor', ["$rootScope", ($rootScope)->
  return{
    'request': (config)->
      if config.url && config.url.match(/^\/api\/v\d+\/.*$/)
        angular.extend(config.headers, {
          'Client-Version': "b3859a1b-0255-4e18-ae2f-cc5d58e0d956"
          'Authorization': "Token=#{$rootScope.api_token}"
          'X-Admin-Authorization': "Token=#{$rootScope.admin_api_token}"
          'Client-Install': "#{$rootScope.client_install_uuid}"
        })
      config
  }
])
